var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"goodslist"},_vm._l((_vm.goodslist),function(item,index){return _c('goodsitem',{key:index,staticStyle:{"cursor":"pointer"},attrs:{"goods-item":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }